"use client";
import { openHelpModal } from "@/redux/features/HelpModal/helpModalSlice";
import React from "react";
import { useDispatch } from "react-redux";

export default function TalkToExpertStripButton() {
  const dispatch = useDispatch();
  return (
    <button onClick={() => dispatch(openHelpModal())} className="text-sm xs:text-base border-2 border-white text-white font-medium px-4 xs:px-5 py-2 rounded-full hover:bg-white/10 transition">
      Talk to Our Experts
    </button>
  );
}
